import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'

// evertel
import { useUI, Row, IconLink } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'
import { ThemeState } from '@evertel/web/theme'
import { DrawerController } from '@evertel/drawer'
import { ContactSupportModal, HeaderHelpDropdown, HeaderNotificationsDropdown, HeaderProfileDropdown } from './elements'
import { HeaderSessionTimeout } from './elements/HeaderSessionTimeout'


const Header: React.FC  = observer(({
    ...props
}) => {

    const { leftNavOpen, toggleLeftNav } = useUI()
    const sessionService = useService(SessionService, [])
    const themeState = useService(ThemeState, [])
    const drawerController = useService(DrawerController, [])

    const [isHelpModalOpen, setIsHelpModalOpen] = useState(false)

    const toggleTheme = () => {
        themeState.setTheme(themeState.theme === 'dark' ? 'light' : 'dark')
    }

    // the documents section has no drawer, so the sidebar toggle is hidden there
    const isInDocuments = drawerController.activeSection === 'everdocs'

    const openHelpModal = () => {
        setIsHelpModalOpen(true)
    }

    return (
        <>
            <Row
                data-bs-theme="dark"
                align="between"
                valign="center"
                className="app-header">

                <div className="position-absolute w-100 top-0 left-0">
                    {sessionService.debugEnabled && (
                        <div className="bg-danger w-100" style={{height: 1}}><span style={{marginLeft: 200}}>debug</span></div>
                    )}
                    {sessionService.testEnabled && (
                        <div className="bg-success w-100" style={{height: 1}}><span style={{marginLeft: 100}}>test</span></div>
                    )}
                </div>

                <div>
                    {(!isInDocuments) &&
                        <IconLink
                            className="ms-3"
                            label=""
                            icon={{
                                name: (leftNavOpen) ? 'arrow-alt-from-right' : 'sidebar',
                                size: 20
                            }}
                            onClick={() => toggleLeftNav('toggle')}
                            aria-expanded={leftNavOpen}
                            title="Toggle the Sidebar"
                            aria-label={leftNavOpen ? 'Collapse Room & DM Sidebar' : 'Expand Room & DM Sidebar'}
                        />
                    }
                </div>
                <Row valign="center">
                    {sessionService.debugEnabled && (
                        <IconLink
                            className="me-3"
                            label=""
                            icon={{
                                name: themeState.theme === 'dark' ? 'sun-bright' : 'moon',
                                size: 18
                            }}
                            onClick={toggleTheme}
                            title={`Switch to ${themeState.theme === 'dark' ? 'light' : 'dark'} mode`}
                            aria-label={`Switch to ${themeState.theme === 'dark' ? 'light' : 'dark'} mode`}
                        />
                    )}
                    <HeaderHelpDropdown openHelpModal={openHelpModal} className="me-3"/>
                    <HeaderSessionTimeout className="me-3" />
                    <HeaderNotificationsDropdown className="me-4" />
                    <HeaderProfileDropdown />
                </Row>
            </Row>

            {/* APP-WIDE MODALS */}
            <ContactSupportModal
                isOpen={isHelpModalOpen}
                onClose={() => setIsHelpModalOpen(false)}
            />
        </>
    )
})

export { Header }
